import UPDATED from './updated.json';
import { SITE_LAUNCH } from './fresh';

/** When a game's code last changed (scripts/game-dates.mjs writes updated.json from git before each build). */
export const gameUpdated = (id: string): string => (UPDATED as Record<string, string>)[id] ?? SITE_LAUNCH;
